var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 254,
    viewBox: "0 0 251 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.465 108.698C167.628 98.7099 85.2629 84.4443 102.388 105.909C134.57 99.8128 257.806 157.454 178.465 108.698Z",
    fill: "url(#paint0_linear_336_52971)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5508 148.428C97.4785 154.546 104.021 157.957 110.142 156.03C115.563 154.324 118.869 149.028 118.226 143.607C116.481 142.361 114.67 141.101 112.925 139.856C109.989 137.797 107.054 135.738 104.133 133.614C103.802 133.711 103.487 133.744 103.182 133.882C97.0352 135.769 93.6231 142.309 95.5508 148.428Z",
    fill: "url(#paint1_linear_336_52971)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.624 170.174C179.188 153.762 184.048 131.95 200.464 121.521C201.462 120.887 202.526 120.267 203.561 119.778C208.907 122.1 214.1 124.799 219.129 127.77C209.654 122.129 199.536 117.682 189.03 114.21C158.42 104.169 124.308 102.464 92.071 103.267C80.8746 107.353 25.2425 48.9637 31.1637 77.3246C35.8637 86.3917 46.0864 99.2941 52.55 109.371C45.426 113.953 1.01507 128.77 21.1492 137.505C46.7781 140.508 73.6509 123.155 96.2715 139.505C116.963 151.586 139.419 162.21 162.775 168.339C172.396 170.86 182.127 172.582 191.931 173.361C191.125 172.359 190.334 171.292 189.624 170.174Z",
    fill: "#4AC9D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4903 100.93C56.3345 100.245 55.2932 99.2243 56.4366 99.1706C56.411 99.7475 56.4906 100.314 56.4903 100.93Z",
    fill: "#4AC9D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.229 135.941C232.081 136.577 232.919 137.278 233.772 137.913C232.959 137.252 232.107 136.617 231.229 135.941Z",
    fill: "#4AC9D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.412 131.731C227.263 132.966 229.059 134.292 230.855 135.617C229.059 134.292 227.223 132.992 225.412 131.731Z",
    fill: "#4AC9D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.312 127.872C221.243 129.056 223.173 130.24 225.049 131.515C223.173 130.24 221.283 129.031 219.312 127.872Z",
    fill: "#4AC9D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.889 138.007C234.767 138.682 235.63 139.423 236.468 140.124C235.565 139.408 234.727 138.708 233.889 138.007Z",
    fill: "#4AC9D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M200.205 173.757C201.359 173.808 202.528 173.795 203.697 173.781C202.528 173.795 201.359 173.808 200.205 173.757Z",
    fill: "#4AC9D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.436 150.758C248.063 151.48 248.731 152.177 249.358 152.9C248.691 152.203 248.063 151.48 247.436 150.758Z",
    fill: "#4AC9D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M236.891 140.527C237.638 141.174 238.36 141.78 239.067 142.452C238.385 141.82 237.638 141.174 236.891 140.527Z",
    fill: "#4AC9D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M244.764 147.97C245.547 148.761 246.291 149.578 247.035 150.395C246.331 149.553 245.547 148.761 244.764 147.97Z",
    fill: "#4AC9D3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M242.297 145.5C242.979 146.132 243.621 146.789 244.289 147.486C243.621 146.789 242.979 146.132 242.297 145.5Z",
    fill: "#4AC9D3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.443 142.774C240.242 143.501 241.065 144.267 241.849 145.058C241.065 144.267 240.267 143.541 239.443 142.774Z",
    fill: "#4AC9D3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.883 173.532C210.633 173.579 210.397 173.56 210.146 173.607C210.397 173.56 210.633 173.579 210.883 173.532Z",
    fill: "#4AC9D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M209.304 173.695C209.159 173.731 209.028 173.702 208.883 173.738C209.028 173.702 209.173 173.666 209.304 173.695Z",
    fill: "#4AC9D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M191.928 173.354C193.278 173.449 194.588 173.569 195.913 173.625C194.588 173.569 193.238 173.474 191.928 173.354Z",
    fill: "#4AC9D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M210.041 173.619C209.871 173.615 209.725 173.651 209.555 173.647C209.66 173.637 209.831 173.64 210.041 173.619Z",
    fill: "#4AC9D3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.568 173.359C212.358 173.381 212.107 173.428 211.896 173.449C212.147 173.402 212.358 173.381 212.568 173.359Z",
    fill: "#4AC9D3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.728 137.327C134.03 135.92 129.88 137.772 128.434 141.494C126.987 145.216 128.88 149.339 132.604 150.786",
    fill: "url(#paint2_linear_336_52971)",
    fillOpacity: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.683 122.014C132.985 120.608 128.835 122.459 127.389 126.181C125.982 129.878 127.835 134.026 131.559 135.473",
    fill: "url(#paint3_linear_336_52971)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M147.726 109.395C144.028 107.989 139.878 109.84 138.432 113.562C136.985 117.284 138.878 121.408 142.602 122.854",
    fill: "url(#paint4_linear_336_52971)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.369 141.256C151.67 139.85 147.521 141.701 146.074 145.423C144.668 149.12 146.521 153.269 150.244 154.715",
    fill: "url(#paint5_linear_336_52971)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M154.324 125.939C150.626 124.533 146.476 126.384 145.029 130.106C143.583 133.828 145.476 137.952 149.199 139.398",
    fill: "url(#paint6_linear_336_52971)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.367 113.32C161.669 111.914 157.519 113.765 156.072 117.487C154.626 121.209 156.519 125.332 160.242 126.779",
    fill: "url(#paint7_linear_336_52971)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M170.068 144.527C166.37 143.12 162.22 144.972 160.773 148.694C159.367 152.39 161.22 156.539 164.943 157.986",
    fill: "url(#paint8_linear_336_52971)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.023 129.217C165.325 127.81 161.175 129.662 159.729 133.384C158.282 137.106 160.175 141.229 163.898 142.675",
    fill: "url(#paint9_linear_336_52971)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.062 116.597C176.364 115.19 172.214 117.041 170.768 120.764C169.321 124.486 171.214 128.609 174.938 130.055",
    fill: "url(#paint10_linear_336_52971)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5448 109.734L85.1578 102.449L83.398 101.269C76.6591 97.8143 67.2181 90.6391 58.1471 83.9577L42.1199 72.9508C33.6287 67.9751 28.1298 67.2645 30.1969 77.2186C34.8963 86.2852 45.1182 99.1866 51.5811 109.263C44.4567 113.845 0.0439761 128.665 20.1778 137.399C44.9684 140.316 71.0038 124.111 93.153 137.955L57.5448 109.734Z",
    fill: "url(#paint11_linear_336_52971)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M185.918 138.942C180.301 148.452 179.457 160.088 183.609 170.233C188.309 170.217 192.988 169.992 197.685 169.53C196.706 168.695 195.78 167.769 194.87 166.778C187.701 158.943 184.759 148.76 185.918 138.942Z",
    fill: "#4AC9D3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.643 145.428C251.221 147.89 251.151 151.961 248.589 154.44C248.053 154.959 247.521 155.461 246.996 155.947C246.513 155.732 246.031 155.503 245.787 155.343C245.159 154.932 243.546 153.464 243.546 153.464C242.242 152.638 240.559 153.617 240.598 155.15C240.648 156.822 241.47 158.444 242.971 159.445C232.38 168.055 224.122 170.022 216.992 171.484C207.763 173.377 197.355 173.773 191.929 173.353C191.123 172.351 190.333 171.283 189.622 170.165C179.188 153.755 184.049 131.943 200.466 121.513C201.464 120.879 202.514 120.324 203.563 119.77L203.563 119.77C204.857 120.335 206.161 120.901 207.472 121.469C221.797 127.683 236.939 134.251 248.643 145.428Z",
    fill: "url(#paint12_linear_336_52971)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M223.736 145.673C222.53 148.151 222.672 150.708 224.062 151.365C225.441 152.037 227.52 150.565 228.726 148.087C229.932 145.609 229.789 143.051 228.4 142.394C227.031 141.708 224.942 143.195 223.736 145.673Z",
    fill: "#2395A0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M160.443 147.137L194.208 153.321L181.038 162.417C172.279 168.487 160.326 162.123 160.4 151.48L160.443 147.137Z",
    fill: "url(#paint13_linear_336_52971)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_52971",
    x1: 114.384,
    y1: 131.554,
    x2: 189.078,
    y2: 95.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_52971",
    x1: 82.3091,
    y1: 137.961,
    x2: 120.778,
    y2: 150.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_52971",
    x1: 120.631,
    y1: 139.471,
    x2: 150.741,
    y2: 148.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_52971",
    x1: 101.898,
    y1: 116.203,
    x2: 172.198,
    y2: 143.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_336_52971",
    x1: 107.618,
    y1: 101.513,
    x2: 177.919,
    y2: 128.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_336_52971",
    x1: 97.8513,
    y1: 126.601,
    x2: 168.152,
    y2: 153.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_52971",
    x1: 102.891,
    y1: 113.651,
    x2: 173.191,
    y2: 141.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_52971",
    x1: 108.611,
    y1: 98.9611,
    x2: 178.911,
    y2: 126.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_52971",
    x1: 98.6773,
    y1: 124.474,
    x2: 168.978,
    y2: 151.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_336_52971",
    x1: 103.716,
    y1: 111.531,
    x2: 174.017,
    y2: 138.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_52971",
    x1: 109.433,
    y1: 96.8398,
    x2: 179.733,
    y2: 124.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5072,
    stopColor: "#93E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_336_52971",
    x1: 96.9934,
    y1: 146.969,
    x2: 22.3165,
    y2: 99.6564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_336_52971",
    x1: 222.969,
    y1: 102.184,
    x2: 210.489,
    y2: 189.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD3D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC9D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_336_52971",
    x1: 194.045,
    y1: 136.729,
    x2: 158.883,
    y2: 165.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DADB9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading5);
export default __webpack_public_path__ + "static/media/loading_5.e1d18b1b35ae0d82fe3bfd7199d183ef.svg";
export { ForwardRef as ReactComponent };